import "../css/style.scss"

import caruselGallery from "./modules/carusel";


jQuery(document).ready(function($) {
    new caruselGallery();
});